import * as React from 'react'
import { FC } from 'react'
import { getStyles } from './useStyles'
import { IMenuOption } from './MenuOption'
import { SubMenuItem } from './SubMenuItem'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { useTheme } from '@mui/material/styles'

interface Props {
  expanded: boolean
  label: React.ReactNode
  options: IMenuOption[]
  handleLinkClick: (url: string) => void
  location: string
}
export const SubMenu: FC<Props> = (props) => {
  const { expanded, label, options } = props
  const styles = getStyles(useTheme())
  return (
    <List sx={styles.subMenuList} disablePadding>
      {!expanded && (
        <ListItem color="primary" sx={styles.subMenuHeader}>
          {label}
        </ListItem>
      )}
      {options.map((item, i) => (
        <SubMenuItem
          key={item.url}
          item={item}
          {...props}
          data-test-id={item.dataTestId ?? `subMenuItem-${i}`}
        />
      ))}
    </List>
  )
}
SubMenu.displayName = 'SubMenu'
